<router-outlet></router-outlet>

<app-spinner></app-spinner>
<app-modal></app-modal>
<app-toast></app-toast>
<app-options-modal></app-options-modal>

<app-base-modal></app-base-modal>
<app-input-modal></app-input-modal>
<app-base-modal></app-base-modal>
<app-base-modal></app-base-modal>
<app-base-modal></app-base-modal>
<app-base-modal></app-base-modal>